import { render } from "./GuestBookCard.vue?vue&type=template&id=86859c96&scoped=true"
import script from "./GuestBookCard.vue?vue&type=script&lang=js"
export * from "./GuestBookCard.vue?vue&type=script&lang=js"

import "./GuestBookCard.vue?vue&type=style&index=0&id=86859c96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86859c96"]])

export default __exports__